import { Injectable } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { addMinutes } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

@Injectable({
  providedIn: 'root',
})
export class BootstrapTimeService {
  public readonly germanTimeZone = 'Europe/Berlin';

  public getCurrentLocalDateTime(): Date {
    return new Date();
  }

  public getCurrentLocalDateTimeFrom(ngbDate: NgbDate): Date {
    return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
  }

  public getCurrentLocalDateTimeOffsetAdjustedFrom(ngbDate: NgbDate): Date {
    let date = this.getCurrentLocalDateTimeFrom(ngbDate);
    if (date.getTimezoneOffset()) {
      date = addMinutes(date, date.getTimezoneOffset() * -1);
    }
    return date;
  }

  public getGermanTodayDate(): Date {
    const localDateTime = this.getCurrentLocalDateTime();
    return toZonedTime(localDateTime, this.germanTimeZone);
  }

  public getGermanDateTimeFrom(ngbDate: NgbDate): Date {
    return toZonedTime(this.getCurrentLocalDateTimeFrom(ngbDate), this.germanTimeZone);
  }
}
